enum DevicePhysicalStatus {
  STOCKED = "stocked",
  PACKED = "packed",
  PRODUCTION = "production",
  TRANSFERRING = "transferring",
  INVENTORY = "inventory",
  PREINSTALLED = "preinstalled",
  INSTALLED = "installed",
  MISSING = "missing",
  WARRANTY = "warranty",
  DAMAGED = "damaged",
}

export default DevicePhysicalStatus
